import React, { useState } from 'react';
import InputForm from '../../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../../Types/ParamsPicklist';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { Input, Spin } from 'antd';
import Table from '../../../../TableResizable';
import { useForm } from 'antd/es/form/Form';
import { MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp, TextFields } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';

import SearchModal from '../../../../SearchModal';
import SearchInput from '../../../../SearchInput';
import SelectMultipleOptionPanier from '../../../../SelectMultipleOptionPanier';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';


let searchParamsQard: ParamsPicklist = { CodeAgence: '', Table: "ParamsQard", Colonne1: "CodeQard", Colonne2: "LibelleQard", Colagence: '101', Choix: 22 }
let searchIndice:Params={CodeAgence:'',Table: "CLIENT",Colonne1:"NUMCLI",Colonne2:"NOMCLI",Colagence:'101',Choix:22}
let searchPlanCpte:Params={CodeAgence:'',Table: "V_COMPTE_CLIENTELE_PLANCP",Colonne1:"IDPLAN",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchPeriod:Params={CodeAgence:'',Table: "v_period_lib",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'101',Choix:22}

let searchSimul : Params={CodeAgence:'',Table: "SimulationQard",Colonne1:"CodeSimul",Colonne2:"Nomcli",Colagence:'101',Choix:22}


function Tab1(props:{form?: any, disabled?: boolean,GetTypeCard:Function}){
  // USER SESSION
  const auth = useAuthUser()
  // const user : Utilisateur = JSON.parse(JSON.stringify(auth()))


  return(

    <div className='tabItem'>
      <div >
       <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
            <Grid item xs={12} md={6}  lg={6} className='border-left'>
             {/* <SearInputM  width={4} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
                <SearchInput width={5} dissabledCode={props.disabled} notRequired enable   form = {props.form}  Titre='Recherche Simulation De financement'  label='Code Simul' name='CodeSimul' Parametre={searchSimul}/>
                <SearchInput width={5}   dissabledCode={!props.disabled} dissabledLib={!props.disabled}  form = {props.form}  Titre='Recherche Client'  label='Indice Client' name='Numcli' Parametre={searchIndice}/>
                <SearchModal width={5}  form={props.form}  Titre='Recherche Périodicité'  label='Périodicité' name='Periodicite' Parametre={searchPeriod}/>
                 <InputForm notRequired width={5} disabled money label='Frais de service' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='MontantFrais'  type='number' error='mobile' />
                {/* <InputForm defaultValue='0' disabled width={5} label='Total Frais Appliqués' icon={<SwipeUp color='disabled' fontSize='small' />} name='cssionApliq' type='text' error='mobile' /> */}
                {/* <InputForm width={5} label='Montant Epargne' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='MONTEPARG'  type='number' error='mobile' /> */}
                {/* <InputForm width={2} label='Taux Intéret Annuel' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='TAUXINT'  type='money' error='mobile' /> */}
               </Grid>
               
              <Grid item xs={12} md={6}  lg={6} className='border-left'>
                {/* <InputForm width={5} label='Nombre Pde Differé' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='NBPERDIF'  type='number' error='mobile' /> */}
                {/* <SearchModal width={7}  form = {props.form}  Titre='Recherche Type Pret'  label='Type Pret' name='TYPEPRET' Parametre={searchTypePret}/> */}
                {/* <SearchModal width={7}  form = {props.form}  Titre='Recherche Type Amortissement'  label='Type Amort' name='TYPAMORT' Parametre={searchTypeAmort}/> */}
                {/* <InputForm width={2} label='Taux Epargne' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='TAUXEPAR'  type='money' error='mobile' /> */}
                <SearchModal width={5}  ExecuteafterSelect1={props.GetTypeCard}  form = {props.form}  Titre='Type de Qard'  label='Type de Qard' name='CodeQard' Parametre={searchParamsQard}/>
                <InputForm width={5} money label='Nombre Echéance' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='NombreEch'  type='number' error='mobile' />
                <InputForm width={5} money label='Montant du financement' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='Montant'  type='number' error='mobile' />
                {/* <SearchModal width={5}  form = {props.form}  Titre='Recherche Type Calcul'  label='Type Calcul' name='TYPCALC' Parametre={searchTypeCalcul}/> */}
                {/* <InputForm width={2} label='Taux Taxe' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='TAUXTAX'  type='money' error='mobile' /> */}
                <InputForm width={5} label='Date 1ère Echéance' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='DatePremEch'  type='date' error='mobile' />
               </Grid>
        </Grid>
       </div>
    </div>
  )
}

export default Tab1;  
